<div class="sticky-header">
  <app-header></app-header>
  <app-alerts *ngIf="
      (!rootScope.isWarningToHide ||
      !rootScope.isErrorToHide ||
      !rootScope.isInfoToHide ||
      !rootScope.isSuccessToHide||!rootScope.isGENSYSErrorToHide || !rootScope.isGensysUDPErrorToHide) && !dashboardService.isErrorMsgVisible
    " [isWarningToHide]="rootScope.isWarningToHide" [isErrorToHide]="rootScope.isErrorToHide"
    [isInfoToHide]="rootScope.isInfoToHide" [isSuccessToHide]="rootScope.isSuccessToHide" [msg]="rootScope.alertMsg">
  </app-alerts>
  <section class="error-wrapper " *ngIf="rootScope.utilityStatusClass==utilityError && !rootScope.getValidFieldValuesApiFailure ">   
    <f-alert variant="error" [ngClass]="dashboardService.isErrorMsgVisible? 'hide1' : 'hide'">
      {{utilityErrMsg}}
      <button (click)="dashboardService.reLunchUtility()" class="btn-alert">Try again</button>
    </f-alert>
</section>
<section class="error-wrapper " *ngIf="rootScope.getValidFieldValuesApiFailure">   
  <f-alert variant="error">
    {{getValidFieldValuesApiFailureMsg}}
    <button (click)="retryValidValueAPi()" class="btn-alert">Try again</button>
  </f-alert>
</section>
</div>
<!-- Need to add a "simulation-mode" class at line no. 21 with ccr-wrapper in case of simulation mode-->

<main class="ccr-wrapper" [ngClass]="{ 'nav-with-child': rootScope.activeLink == 'search' ,
                'simulation-mode': (rootScope?.simulationData?.isSimulationModeActive||(rootScope.invalidENVBanner&&rootScope.isGenesysLoggedIn))
}">
  <router-outlet *ngIf="rootScope.loadUI"></router-outlet>

  <app-loader [loaderType]="loaderType" *ngIf="loading$ | async"></app-loader>
</main>